import React from 'react';
import { Field, ErrorMessage } from 'formik';

import {
    container,
    light,
    labelBox,
    input,
    checkbox,
    checkmark,
    labelContent,
    errorBox,
} from './checkbox.module.scss';
import CheckIcon from '../../../assets/images/svg/checkmark.svg';

import Error from './error';
import Markdown from '../../hoc/markdown';

export interface ICheckboxProps {
    className?: string;
    boxClassName?: string;
    name: string;
    identifier?: string | number;
    label: string;
    isLight?: boolean;
}

const Checkbox: React.FC<ICheckboxProps & Record<string, any>> = ({
    className = '',
    boxClassName = '',
    name,
    identifier = '',
    label,
    isLight = false,
    ...rest
}) => {
    return (
        <div className={`${container} ${className} ${isLight ? light : ''}`}>
            <label htmlFor={`${name}${identifier}`} className={labelBox}>
                <Field
                    type="checkbox"
                    id={`${name}${identifier}`}
                    name={name}
                    className={input}
                    {...rest}
                />
                <span className={`${checkbox} ${boxClassName}`}>
                    <CheckIcon className={checkmark} />
                </span>
                <Markdown className={labelContent}>{label}</Markdown>
            </label>
            <div className={errorBox}>
                <ErrorMessage name={name} component={Error} />
            </div>
        </div>
    );
};

export default Checkbox;
